import React from "react";
import styled from "styled-components";
import { NavigationControl as GLNavigationControl } from "react-map-gl";

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function NavigationControl() {
  const { breakpoints } = useTheme();
  const isLarge = useMediaQuery(breakpoints.up("md"));
  return isLarge && <StyledNavigationControl />;
}

const StyledNavigationControl = styled(GLNavigationControl)`
  position: absolute;
  right: ${({ theme }) => theme.spacing(2)}px;
  bottom: ${({ theme }) => theme.spacing(4)}px;
  z-index: 99;
`;
